module.exports = __webpack_public_path__ + "img/title2.cbb85834.png";